var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoGreegoBig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 36,
    viewBox: "0 0 93 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 869"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.6104 18.5233V18.496V18.4905V18.4851C15.5722 18.0567 15.2311 17.7183 14.8 17.6829H14.7946H14.7891H8.58423C8.58423 17.6829 8.5624 17.6829 8.55421 17.6829C8.06579 17.6829 7.67014 18.0785 7.67014 18.5669C7.67014 19.0226 8.01667 19.3992 8.45871 19.4456L8.52693 19.451C8.53511 19.451 8.54603 19.451 8.55421 19.451H8.55967H8.57331H13.7741C13.3402 22.3952 10.7971 24.5999 7.80657 24.5999C4.48039 24.5999 1.7736 21.8931 1.7736 18.5669C1.7736 15.2408 4.48039 12.534 7.80657 12.534C9.79846 12.534 11.6594 13.5217 12.789 15.1725C12.8081 15.1998 12.8272 15.2298 12.8463 15.2571V15.2653C13.01 15.4781 13.2556 15.6037 13.523 15.6091H13.5285C13.5285 15.6091 13.5421 15.6091 13.5476 15.6091C13.553 15.6091 13.5612 15.6091 13.5667 15.6091H13.5721C14.0551 15.5955 14.4344 15.2053 14.4344 14.7223C14.4344 14.5559 14.388 14.3894 14.2952 14.2475L14.287 14.2339L14.2761 14.2175C12.8218 12.0565 10.4015 10.7686 7.80111 10.7686C3.50081 10.7686 0 14.2666 0 18.5697C0 22.8727 3.49809 26.3708 7.80111 26.3708C9.87213 26.3708 11.8204 25.5686 13.2911 24.1115C14.7591 22.6544 15.5804 20.7144 15.5995 18.6488V18.6188C15.5995 18.6024 15.5995 18.586 15.5995 18.5724C15.5995 18.5588 15.5995 18.5451 15.5995 18.5315L15.6104 18.5233ZM0.245575 17.2054C0.278319 17.0171 0.319248 16.8288 0.368363 16.646C0.321977 16.8288 0.281047 17.0171 0.245575 17.2054Z",
    fill: "#01D3B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.761 10.8037H25.7555H25.7501C25.6928 10.8092 25.6327 10.8174 25.5754 10.8228C23.7227 11.0493 22.0091 11.9388 20.7485 13.3304C19.507 14.7029 18.7921 16.4683 18.7348 18.3156H18.7321V18.4302V25.3718V25.5955C18.7921 26.0348 19.1714 26.365 19.6161 26.365C20.0609 26.365 20.4374 26.0348 20.4975 25.601V25.5928V25.5846V18.5666C20.4975 15.5106 22.7868 12.9348 25.821 12.5773C25.8346 12.5773 25.8483 12.5746 25.8647 12.5719C25.8838 12.5719 25.9056 12.5664 25.9247 12.5637H25.9301H25.9356C26.3476 12.4818 26.6478 12.1134 26.6478 11.6932C26.6478 11.2048 26.2494 10.8064 25.761 10.8064V10.8037Z",
    fill: "#01D3B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M39.1666 20.0732C39.1284 20.0732 39.0901 20.0732 39.0519 20.0814C39.0192 20.0869 38.9892 20.0923 38.9592 20.0978C38.9292 20.106 38.8991 20.1142 38.8691 20.1251C38.6454 20.2042 38.468 20.3652 38.3643 20.5807C38.3398 20.6299 38.3234 20.679 38.3098 20.7308C37.5949 22.589 36.015 23.9724 34.0886 24.4336C33.6275 24.5454 33.1527 24.6 32.6834 24.6C30.2303 24.6 27.9983 23.0856 27.087 20.8154L32.888 19.4238L32.9999 19.3965L39.5349 17.8303L39.6904 17.7921H39.6959L39.7014 17.7894C40.1325 17.6393 40.3753 17.1891 40.2689 16.747C39.8514 15.0089 38.8882 13.5082 37.4803 12.414C36.1132 11.3498 34.4133 10.7632 32.6915 10.7632C32.0803 10.7632 31.4664 10.8369 30.8661 10.9787C28.8387 11.4644 27.1252 12.7087 26.0337 14.485C24.945 16.2613 24.6121 18.3542 25.0978 20.3816C25.5153 22.1197 26.4785 23.6204 27.8865 24.7146C29.2535 25.7788 30.9534 26.3654 32.6752 26.3654C33.2864 26.3654 33.9003 26.2917 34.5006 26.1499C37 25.5496 39.0438 23.7569 39.966 21.3529C39.9933 21.2984 40.0152 21.2411 40.0288 21.181C40.0643 21.0419 40.0643 20.8945 40.0315 20.7554C39.936 20.3543 39.5786 20.0732 39.1666 20.0732ZM31.2754 12.6978C31.7365 12.5859 32.2113 12.5313 32.6806 12.5313C35.1337 12.5313 37.3657 14.0457 38.277 16.3159L26.6722 19.0964C26.4075 16.1331 28.3667 13.3963 31.2727 12.6978H31.2754Z",
    fill: "#01D3B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M56.8697 20.0732C56.8315 20.0732 56.7933 20.0732 56.7551 20.0814C56.7223 20.0869 56.6923 20.0923 56.6623 20.0978C56.6323 20.106 56.6023 20.1142 56.5723 20.1251C56.3485 20.2042 56.1712 20.3652 56.0675 20.5807C56.0429 20.6299 56.0265 20.679 56.0129 20.7308C55.2953 22.589 53.7181 23.9724 51.7917 24.4336C51.3306 24.5454 50.8558 24.6 50.3865 24.6C47.9335 24.6 45.7015 23.0856 44.7901 20.8154L50.5911 19.4238L50.703 19.3965L57.238 17.8303L57.3936 17.7921H57.399L57.4045 17.7894C57.8356 17.6393 58.0785 17.1891 57.972 16.747C57.5546 15.0089 56.5914 13.5082 55.1834 12.414C53.8164 11.3498 52.1164 10.7632 50.3947 10.7632C49.7835 10.7632 49.1695 10.8369 48.5692 10.9787C44.3863 11.9801 41.7995 16.1986 42.8009 20.3816C43.2184 22.1197 44.1816 23.6204 45.5896 24.7146C46.9566 25.7788 48.6565 26.3654 50.3783 26.3654C50.9895 26.3654 51.6034 26.2917 52.2037 26.1499C54.7032 25.5496 56.7469 23.7569 57.6692 21.3529C57.6964 21.2984 57.7183 21.2411 57.7319 21.181C57.7674 21.0419 57.7674 20.8945 57.7347 20.7554C57.6391 20.3543 57.2817 20.0732 56.8697 20.0732ZM48.9785 12.7005C49.4397 12.5886 49.9144 12.5341 50.3838 12.5341C52.8368 12.5341 55.0688 14.0484 55.9801 16.3186L44.3753 19.0991C44.1107 16.1358 46.0698 13.399 48.9758 12.7005H48.9785ZM55.901 21.2684C55.9829 21.1046 56.0538 20.9355 56.122 20.7636C56.0566 20.9355 55.9829 21.1019 55.901 21.2684ZM56.8588 20.1906C56.8588 20.1906 56.867 20.1906 56.8697 20.1906C56.8779 20.1906 56.8861 20.1906 56.8942 20.1906C56.8833 20.1906 56.8724 20.1906 56.8588 20.1906ZM57.6228 20.7827C57.6173 20.7581 57.6091 20.7363 57.6037 20.7144C57.6119 20.7363 57.6173 20.7608 57.6228 20.7827Z",
    fill: "#01D3B8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M90.2138 13.5189L67.9537 0.688977C66.3602 -0.230567 64.3956 -0.230567 62.7994 0.694434C61.2058 1.61671 60.2235 3.31936 60.2263 5.15845L60.2454 30.8511C60.2454 32.6929 61.2304 34.3928 62.8266 35.3124C63.6234 35.7708 64.5129 36 65.3997 36C66.2865 36 67.1815 35.7681 67.981 35.3069L90.2219 22.4442C91.8154 21.522 92.795 19.8193 92.795 17.9775C92.795 16.1357 91.81 14.4357 90.2138 13.5162V13.5189Z",
    fill: "url(#paint0_linear_8_478)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M82.2432 26.9789L75.79 20.2393C75.79 20.2393 74.7613 24.1848 69.8717 24.8834C64.9793 25.5819 61.9205 23.5955 61.9205 23.5955L70.6111 33.7214L82.2432 26.9817V26.9789Z",
    fill: "url(#paint1_linear_8_478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M82.4343 26.9246L78.0494 22.5942L76.4341 23.8958L80.3933 28.1306L82.4343 26.9246Z",
    fill: "url(#paint2_linear_8_478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M83.6591 22.9737L73.1458 11.6909L71.7296 13.1562L82.1611 24.4718L83.6591 22.9737Z",
    fill: "url(#paint3_linear_8_478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M82.2432 27.0608L72.835 17.0195L67.6179 18.4848L78.2567 29.3774L82.2432 27.0608Z",
    fill: "url(#paint4_linear_8_478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M92.713 18.8016L88.8411 13.3198C88.8411 13.3198 91.4769 19.0472 87.0784 23.282C82.6799 27.5168 76.4886 23.8168 76.4886 23.8168L80.3878 28.0653L90.3255 22.4116C90.3255 22.4116 91.2914 21.7758 91.9217 20.8699C92.5547 19.964 92.713 18.8043 92.713 18.8043V18.8016Z",
    fill: "url(#paint5_linear_8_478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M83.8857 26.1035L70.5318 11.8819L64.8973 11.3198L59.8411 18.3897L72.9112 32.4475L83.8857 26.1035Z",
    fill: "url(#paint6_linear_8_478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M92.3254 20.1578L84.557 11.4426L78.7887 10.9487L74.2265 18.5125L82.104 27.1294L90.0634 22.5126C90.0634 22.5126 90.8301 22.1142 91.3513 21.5549C91.8725 20.9955 92.3254 20.1578 92.3254 20.1578Z",
    fill: "url(#paint7_linear_8_478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M82.2432 26.9789L75.79 20.2393C75.79 20.2393 74.7613 24.1848 69.8717 24.8834C64.9793 25.5819 61.9205 23.5955 61.9205 23.5955L70.6111 33.7214L82.2432 26.9817V26.9789Z",
    fill: "url(#paint8_linear_8_478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M85.9266 25.2412L73.1458 11.6909L71.7296 13.1562L82.1611 24.4718L85.9266 25.2412Z",
    fill: "url(#paint9_linear_8_478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M83.8857 26.1035L70.5318 11.8819L64.8973 11.3198L59.8411 18.3897L72.9112 32.4475L83.8857 26.1035Z",
    fill: "url(#paint10_linear_8_478)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M74.1503 18.6271L74.0357 18.5862L74.0193 18.7062L74.0111 18.7744C73.6264 21.8496 70.9987 24.1662 67.899 24.1662C64.5019 24.1662 61.7351 21.4021 61.7351 18.0022C61.7351 14.6024 64.4992 11.8383 67.899 11.8383C69.3315 11.8383 70.7286 12.3458 71.8337 13.2653C71.9073 13.3254 71.981 13.3909 72.052 13.4564L72.0574 13.4618L72.0656 13.4673C72.2293 13.571 72.4203 13.6255 72.6141 13.6255C72.7123 13.6255 72.8132 13.6119 72.9087 13.5819C73.3399 13.4536 73.6427 13.0471 73.6427 12.5968C73.6427 12.4822 73.6236 12.3649 73.5827 12.253C73.5391 12.1275 73.4708 12.0129 73.3835 11.9147H73.3808L73.3781 11.9065C73.3126 11.8492 73.2526 11.7946 73.1953 11.7455C71.7191 10.4931 69.8391 9.80273 67.9017 9.80273C63.3831 9.80273 59.7077 13.4782 59.7077 17.9968C59.7077 22.5154 63.3831 26.1908 67.9017 26.1908C70.0764 26.1908 72.1229 25.3477 73.6673 23.8169C74.7342 22.7582 75.49 21.4376 75.8475 19.9968C76.0166 19.3174 74.3413 18.6898 74.1503 18.6216V18.6271ZM72.8842 13.4946C72.9415 13.4782 72.9933 13.4564 73.0452 13.4291C72.9933 13.4564 72.9388 13.4782 72.8842 13.4946Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M69.7107 23.8877C69.7107 23.8877 71.4461 23.4238 72.6603 21.9149C74.0628 20.174 73.9837 18.5996 73.9837 18.5996L75.9756 19.5574C75.9756 19.5574 75.7409 20.8343 74.8978 22.2614C73.0342 25.4211 69.738 25.9969 69.738 25.9969L69.7107 23.8877Z",
    fill: "url(#paint11_linear_8_478)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M82.1425 9.81083C80.0961 9.81083 78.1369 10.5694 76.628 11.9446C75.1791 13.2653 74.2514 15.0525 74.014 16.9898H68.5376C67.9783 16.9898 67.5253 17.4428 67.5253 18.0021C67.5253 18.5615 67.9783 19.0145 68.5376 19.0145H74.014C74.2514 20.9518 75.1791 22.739 76.628 24.0597C78.1397 25.4376 80.0988 26.1962 82.1453 26.1962C86.6639 26.1962 90.3393 22.5207 90.3393 18.0021C90.3393 13.4836 86.6639 9.80811 82.1453 9.80811L82.1425 9.81083ZM82.1425 24.1661C78.7454 24.1661 75.9786 21.402 75.9786 18.0021C75.9786 14.6023 78.7427 11.8382 82.1425 11.8382C85.5424 11.8382 88.3065 14.6023 88.3065 18.0021C88.3065 21.402 85.5424 24.1661 82.1425 24.1661Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8_478",
    x1: 62.652,
    y1: 0.94001,
    x2: 79.2502,
    y2: 29.0393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#45E092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#26CBB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#05B5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#14A9E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#3E8AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#5C74EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#6F66EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7662ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8_478",
    x1: 77.8092,
    y1: 31.5794,
    x2: 65.8442,
    y2: 19.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F5F5F5",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#DBDCDD",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#B2B3B5",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8_478",
    x1: 81.6539,
    y1: 27.7677,
    x2: 77.0999,
    y2: 23.2218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FAFAFA",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#EEEFEF",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#DBDBDC",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BFC1C2",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#9D9EA1",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8_478",
    x1: 83.1816,
    y1: 23.5986,
    x2: 72.188,
    y2: 12.6268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B3B4B7",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8_478",
    x1: 80.9089,
    y1: 28.5534,
    x2: 69.2059,
    y2: 16.8722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B3B4B7",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8_478",
    x1: 88.4591,
    y1: 24.529,
    x2: 82.0987,
    y2: 18.1795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#F1F2F2",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D4D5D6",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#BDBEC0",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#AAACAE",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9D9FA1",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#95979A",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8_478",
    x1: 79.8992,
    y1: 30.3246,
    x2: 62.8644,
    y2: 13.3226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#F8F8F8",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E5E6E7",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#C8C9CA",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#9FA0A3",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8_478",
    x1: 88.5627,
    y1: 24.5072,
    x2: 76.876,
    y2: 12.8451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#ECECED",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C6C7C8",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AAABAE",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#999B9D",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8_478",
    x1: 77.8092,
    y1: 31.5794,
    x2: 65.8442,
    y2: 19.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CDCECF",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#A3A4A7",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8_478",
    x1: 85.4655,
    y1: 25.8797,
    x2: 72.1853,
    y2: 12.6241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B3B4B7",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8_478",
    x1: 79.8992,
    y1: 30.3246,
    x2: 62.8644,
    y2: 13.3226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#F8F8F8",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E5E6E7",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#C8C9CA",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#9FA0A3",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_8_478",
    x1: 69.3505,
    y1: 25.7622,
    x2: 74.3848,
    y2: 20.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#ECEDED",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CCCDCF",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#B3B5B7",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#A1A3A6",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#96989B",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGreegoBig);
export default __webpack_public_path__ + "static/media/logo_greego_big.f830c241659dbdfe98f6a8c7eec849ea.svg";
export { ForwardRef as ReactComponent };